import { checkNewVersion } from '@dmp/utils/version';

export const importWithRetry = <T>(importer: () => Promise<{ default: T }>) => {
  return async () => {
    try {
      const module = await importer();
      return module.default;
    } catch (error) {
      console.log('error', error);
      if (error) {
        checkNewVersion();
      }
      return null;
    }
  };
};
